<section class="datenschutz-section">
  <div class="container">
    <div class="datenschutz-header">
      <h1 class="headline-text">Datenschutzerklärung</h1>
      <button class="back-button" (click)="handleBackButtonClick()">
        <app-icon iconName="redo" iconColor="#0d1424" iconSize="2.4rem"></app-icon>
        <p>zurück</p>
      </button>
    </div>

    <h2 class="header-text">1. Name und Kontaktdaten des Verantwortlichen</h2>
    <p class="line name">
      Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne der
      Datenschutz-Grundverordnung (DSGVO) ist:
    </p>
    <p class="line">Helix GPO UG (haftungsbeschränkt) & Co. KG</p>
    <p class="line">Erftstraße 50</p>
    <p class="line">41460 Neuss</p>
    <p class="line">Deutschland</p>
    <p class="line name-bottom">Email: helix.gpo&#64;gmail.com</p>
    <p class="line name">
      Vertreten durch die Geschäftsführer der Helix GPM UG (haftungsbeschränkt):
    </p>
    <p class="line">
      Felix Breuer, Weberstraße 39, 41464 Neuss, felixbreuer62&#64;gmail.com,
      +49 1511 4924348
    </p>
    <p class="line bottom">
      Henry Heller, Erftstraße 50, 41460 Neuss, heller-henry&#64;web.de, +49 173
      2471408
    </p>

    <h2 class="header-text">
      2. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck
      von deren Verwendung
    </h2>
    <p class="line betw-bottom">
      Beim Besuch unserer Website werden durch den auf Ihrem Endgerät zum
      Einsatz kommenden Browser automatisch Informationen an den Server unserer
      Website gesendet. Diese Informationen werden temporär in einem sogenannten
      Logfile gespeichert. Folgende Informationen können dabei erfasst werden:
    </p>

    <p class="line">- IP-Adresse des anfragenden Rechners</p>
    <p class="line">- Datum und Uhrzeit des Zugriffs</p>
    <p class="line">- Name und URL der abgerufenen Datei</p>
    <p class="line">
      - Website, von der aus der Zugriff erfolgt (Referrer-URL)
    </p>
    <p class="line name-bottom">
      - verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie der
      Name Ihres Access-Providers
    </p>

    <p class="line name betw-bottom">
      Die genannten Daten werden durch uns zu folgenden Zwecken verarbeitet:
    </p>

    <p class="line">
      - Gewährleistung eines reibungslosen Verbindungsaufbaus der Website
    </p>
    <p class="line">
      - Gewährleistung einer komfortablen Nutzung unserer Website
    </p>
    <p class="line">- Auswertung der Systemsicherheit und -stabilität</p>
    <p class="line name-bottom">- weitere administrative Zwecke</p>

    <p class="line name-bottom">
      Die Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. f
      DSGVO. Unser berechtigtes Interesse folgt aus oben aufgelisteten Zwecken.
    </p>

    <p class="line name betw-bottom">Testimonials und Referenzen:</p>
    <p class="line">
      Auf unserer Website bieten wir die Möglichkeit, Erfahrungsberichte
      (Testimonials) sowie Projekt-Referenzen anzuzeigen.
    </p>
    <p class="line betw-bottom">
      Wenn Nutzer über eine separate Anwendung ein Testimonial abgeben, werden
      folgende personenbezogene Daten erhoben und verarbeitet:
    </p>

    <p class="line">- Name (ggf. auch abgekürzt oder anonymisiert)</p>
    <p class="line">- Bewertungs-/Meinungstext</p>
    <p class="line name-bottom">- optional: weitere freiwillige Angaben</p>
    <!-- Todo: Ergänzung von entsprechenden Felder -->

    <p class="line bottom">
      Diese Daten werden ausschließlich zum Zweck der Veröffentlichung
      ausgewählter Testimonials und Referenzen auf unserer Website erhoben. Die
      Verarbeitung erfolgt auf Grundlage Ihrer freiwilligen Einwilligung (Art. 6
      Abs. 1 lit. a DSGVO). Eine erteilte Einwilligung kann jederzeit widerrufen
      werden. Die Daten werden nur für die Dauer der Veröffentlichung
      gespeichert und anschließend gelöscht.
    </p>

    <h2 class="header-text">3. Weitergabe von Daten an Dritte</h2>
    <p class="line name betw-bottom">
      Eine Übermittlung Ihrer persönlichen Daten an Dritte findet nicht statt,
      außer:
    </p>

    <p class="line">
      - Sie haben Ihre ausdrückliche Einwilligung dazu erteilt (Art. 6 Abs. 1
      lit. a DSGVO),
    </p>
    <p class="line">
      - die Weitergabe ist zur Geltendmachung, Ausübung oder Verteidigung von
      Rechtsansprüchen erforderlich (Art. 6 Abs. 1 lit. f DSGVO) und kein Grund
      zur Annahme besteht, dass Sie ein überwiegendes schutzwürdiges Interesse
      an der Nichtweitergabe Ihrer Daten haben,
    </p>
    <p class="line">
      - für den Fall, dass für die Weitergabe eine gesetzliche Verpflichtung
      besteht (Art. 6 Abs. 1 lit. c DSGVO),
    </p>
    <p class="line name-bottom">
      - sowie dies gesetzlich zulässig und für die Abwicklung von
      Vertragsverhältnissen mit Ihnen erforderlich ist (Art. 6 Abs. 1 lit. b
      DSGVO).
    </p>

    <p class="line bottom">
      Eine Weitergabe der im Rahmen der Testimonials oder Referenzen erhobenen
      Daten erfolgt ausschließlich innerhalb unseres Unternehmens. Eine
      Übermittlung an Dritte oder externe Dienstleister erfolgt nicht.
    </p>

    <h2 class="header-text">4. Betroffenenrechte</h2>
    <p class="line name betw-bottom">Sie haben das Recht:</p>
    <p class="line">
      - gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten
      personenbezogenen Daten zu verlangen;
    </p>
    <p class="line">
      - gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder
      Vervollständigung Ihrer bei uns gespeicherten personenbezogenen Daten zu
      verlangen;
    </p>
    <p class="line">
      - gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten
      personenbezogenen Daten zu verlangen, soweit nicht die Verarbeitung zur
      Erfüllung einer rechtlichen Verpflichtung erforderlich ist;
    </p>
    <p class="line">
      - gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer
      personenbezogenen Daten zu verlangen;
    </p>
    <p class="line">
      - gemäß Art. 20 DSGVO Ihre personenbezogenen Daten in einem
      strukturierten, gängigen und maschinenlesebaren Format zu erhalten oder
      die Übermittlung an einen anderen Verantwortlichen zu verlangen;
    </p>
    <p class="line">
      - gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung jederzeit
      gegenüber uns zu widerrufen;
    </p>
    <p class="line bottom">
      - gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren.
    </p>

    <h2 class="header-text">5. Widerspruchsrecht</h2>
    <p class="line">
      Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten
      Interessen verarbeitet werden (Art. 6 Abs. 1 lit. f DSGVO), haben Sie das
      Recht, Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten
      einzulegen, sofern dafür Gründe vorliegen, die sich aus Ihrer besonderen
      Situation ergeben.
    </p>
    <p class="line">
      Möchten Sie von Ihrem Widerrufs- oder Widerspruchsrecht Gebrauch machen,
      genügt eine E-Mail an: <span class="mail">helix.gpo&#64;gmail.com</span>
    </p>
  </div>
</section>
